import type { FormFlowStep } from '../../../../../types/formFlow';

/** Human-readable line for chat history + PDF-facing labels. */
export function formatCommittedDisplay(
  step: FormFlowStep,
  raw: string,
  t: (key: string) => string,
  wheelLocale: string
): string {
  const v = raw.trim();

  if (step.fieldName === 'constructionExperienceYears' && !v) {
    return t('forms.workerRegistry.constructionExperienceYears.skipped');
  }

  if (!v) return '';

  if (step.fieldType === 'choice' && step.options?.length) {
    const opt = step.options.find((o) => o.value === v);
    if (opt?.labelKey) {
      const tr = t(opt.labelKey);
      if (tr !== opt.labelKey) return tr;
    }
    return opt?.label ?? v;
  }

  if (step.fieldType === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const d = new Date(`${v}T12:00:00`);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleDateString(wheelLocale, { year: 'numeric', month: 'short', day: 'numeric' });
    }
  }

  if (step.fieldName === 'constructionExperienceYears' && /^\d+$/.test(v)) {
    return `${v}`;
  }

  return v;
}

export function promptTextForStep(step: FormFlowStep, t: (key: string) => string): string {
  const k = step.promptKey;
  const tr = t(k);
  if (tr !== k) return tr;
  return step.fieldName;
}
